import { IconClose16 } from '@cian/ui-kit/icons';

import * as styles from './CloseFullscreenMapButton.css';

interface ICloseFullscreenMapButtonProps {
  onClick(): void;
}

export function CloseFullscreenMapButton({ onClick }: ICloseFullscreenMapButtonProps) {
  return (
    <div className={styles['close']} onClick={onClick}>
      <IconClose16 color={'white_100'} />
    </div>
  );
}
